import React from 'react';

interface AutofillChipProps {
  visible: boolean;
}

const AutofillChip: React.FC<AutofillChipProps> = ({ visible }) => {
  if (!visible) return null;
  return (
    <span
      role="status"
      aria-label="Pre-filled from uploaded documents"
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium"
      style={{
        backgroundColor: '#EEF2FF',
        color: '#4338CA',
        border: '1px solid #C7D2FE',
      }}
    >
      ✨ From documents
    </span>
  );
};

export default AutofillChip;
